import { Injectable } from '@angular/core';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import Sublayer from '@arcgis/core/layers/support/Sublayer';
import { BehaviorSubject } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class BrowseMapImageServiceLayerService {

  private wellLayerId: number = 0;
  private injectionTableId: number = 1;

  public currentMapImageService: BehaviorSubject<MapImageLayer> = new BehaviorSubject<MapImageLayer>(null);

  public currentWellLayer: BehaviorSubject<Sublayer> = new BehaviorSubject<Sublayer>(null);
  public currentInjectionTable: BehaviorSubject<Sublayer> = new BehaviorSubject<Sublayer>(null);

  constructor(public configService: ConfigService)
  {
    this.configService.configState.subscribe((newConfigState: any) => {
      this.init(newConfigState);
    });
  }

  protected init(configState: any) {

    if(configState != null && configState.wellsLayerUrl != null) {
      var imageLayer = new MapImageLayer({
        title: "TexNet Disposal Data",
        url: configState.wellsLayerUrl,
        useViewTime: true
      });

    this.currentMapImageService.next(imageLayer);

    this.currentMapImageService.subscribe((imgLyr: MapImageLayer) => {

      imgLyr.when((il) => {  
        imgLyr.sublayers.forEach((sl) => {
          if (sl.id == this.wellLayerId) {
            this.currentWellLayer.next(sl);
          }

          if (sl.id == this.injectionTableId) {
            this.currentInjectionTable.next(sl);
          }
        });
      });
    }); 
  }
  }
}
